// The file contents for the current environment will overwrite these during build.
// The build system defaults to the dev environment which uses `environment.ts`, but if you do
// `ng build --env=prod` then `environment.prod.ts` will be used instead.
// The list of which env maps to which file can be found in `.angular-cli.json`.

// export const environment = {
//   production: false

// };


// 02/06/25 modified
import { firebaseConfig } from './firebase.config';

export const environment = {
  production: false,
  firebase: firebaseConfig  // 기존 설정 재사용
};


// WEBPACK FOOTER //
// C:/Users/VML/Desktop/vml6/src/environments/environment.ts